import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CoreService } from '@portal-output/core/services/core.service';
import { map } from 'rxjs';

export const returnUrlResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  const coreService = inject(CoreService);

  const returnUrl: string = route.queryParams.returnUrl ?
    route.queryParams.returnUrl + (route.fragment ? '#' + route.fragment : '') : '';

  return coreService.setReturnUrl$(returnUrl).pipe(
    map(() => returnUrl)
  );
};
